import { DetalheSection } from './styles'
import { FaMusic } from 'react-icons/fa'
import { FaGuitar, FaDrum } from 'react-icons/fa'
import {
  GiGuitarBassHead,
  GiBanjo,
  GiMusicalKeyboard,
  GiGuitar
} from 'react-icons/gi'
import { PiGuitarFill } from 'react-icons/pi'
import { IconType } from 'react-icons'

const iconesPorInstrumento: { [key: string]: IconType } = {
  Violão: FaGuitar,
  Guitarra: GiGuitar,
  Contrabaixo: GiGuitarBassHead,
  Bateria: FaDrum,
  Teclado: GiMusicalKeyboard,
  Ukulelê: PiGuitarFill,
  Cavaquinho: GiBanjo
}

// Definimos o que o componente espera receber
interface Props {
  instrumento: {
    nome: string
    img: string
    descricao: string // Adicionei descrição aqui
    topicos?: string[] // E uma lista de tópicos para dar mais "corpo" ao card
  } | null // Pode ser null se o usuário ainda não clicou em nada
}

const topicosPorInstrumento: { [key: string]: string[] } = {
  Violão: [
    'Postura e Digitação',
    'Acordes e Campos Harmônicos',
    'Ritmos e Levadas Populares',
    'Leitura de Cifras'
  ],
  Guitarra: [
    'Técnicas de Palhetada e Legato',
    'Escalas e Improvisação',
    'Configuração de Set e Timbres',
    'Solos e Riffs Clássicos'
  ],
  Teclado: [
    'Independência das Mãos',
    'Formação de Acordes e Inversões',
    'Leitura de Partituras',
    'Uso de Sintetizadores'
  ],
  Contrabaixo: [
    'Técnicas de Pizzicato e Slap',
    'Criação de Grooves e Walking Bass',
    'Condução Rítmica e Harmônica',
    'Escalas Pentatônicas e Modos'
  ],
  Cavaquinho: [
    'Palhetada e Levadas de Samba',
    'Acordes e Inversões no Braço',
    'Repertório de Samba e Pagode',
    'Leitura de Cifras e Percepção'
  ],
  Ukulelê: [
    'Batidas Básicas e Avançadas',
    'Formação de Acordes (Shapes)',
    'Dedilhados e Fingerstyle',
    'Repertório Popular e Havaiano'
  ],
  Bateria: [
    'Postura e Rudimentos Básicos',
    'Independência dos 4 Membros',
    'Ritmos (Rock, Pop, Jazz, Samba)',
    'Leitura de Partitura Rítmica'
  ]
}

const DetalhesAula = ({ instrumento }: Props) => {
  if (!instrumento) return null // Se não clicou em nada, não renderiza nada

  const IconeFundo = (iconesPorInstrumento[instrumento.nome] ||
    FaMusic) as React.ElementType

  return (
    <DetalheSection id="detalhes-aula">
      <div className="conteudo">
        <div className="icone-fundo-card">
          <IconeFundo size={120} />
        </div>

        <div className="texto">
          <h2>Aulas de {instrumento.nome}</h2>
          <p>{instrumento.descricao}</p>

          {/* Nova lista de tópicos para dar "corpo" ao card */}
          <ul className="lista-topicos">
            {/* Buscamos a lista no objeto acima usando o nome do instrumento atual */}
            {topicosPorInstrumento[instrumento.nome]?.map((topico, index) => (
              <li key={index}>
                {FaMusic({})}
                <span>{topico}</span>
              </li>
            ))}
          </ul>
          <a href="#contato" className="btn-contato">
            Falar com o Professor
          </a>
        </div>
      </div>
    </DetalheSection>
  )
}
{
  /* <div className="midia">
          <img src={instrumento.img} alt={instrumento.nome} />
        </div> */
}

export default DetalhesAula
